export default __webpack_public_path__ + "static/media/arrow-down.c97d0cfe.svg";